var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakfastNomeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126px",
    height: "60px",
    viewBox: "0 0 126 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ontbijt done@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ontbijt-nomeal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#f37160",
    fillRule: "nonzero",
    points: "2 49.6777344 9.09082031 33.5400391 15.1503906 21.8554688 25.9980469 15.1484375 34.2363281 11.9697266 44.9228516 5.27246094 58.3681641 2 69.5585938 2 80.8632812 5.27246094 90.7119141 11.9697266 98.7255859 15.1484375 109.932617 19.8935547 115.887695 31.5527344 123.167969 44.0058594 125 53.8642578 121.731445 58 113.902344 56.1484375 105.323242 49.6777344 98.7255859 48.1386719 90.7119141 46.1132812 80.8632813 48.1386719 69.5585938 46.1132812 63.5 46.1132812 55.6572266 46.1132812 47.7890625 48.1386719 40.5341797 46.1132812 35.7470703 44.0058594 34.2363281 48.1386719 25.9980469 48.1386719 19.9746094 51.9355469 7.19628906 58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.392,29.1102 C5.272,34.3002 -4.238,47.8302 2.142,55.0002 C2.142,55.0002 5.762,59.5292 23.342,45.3192",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.892,29.1102 C117.012,34.3102 126.512,47.8302 120.142,55.0002 C120.142,55.0002 116.512,59.5292 98.912,45.3002",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.142,11.9999 C30.142,11.9999 11.142,14.9999 9.142,27.9999 C9.142,27.9999 23.392,56.4999 35.222,42.1999",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.142,11.9999 C92.142,11.9999 111.142,14.9999 113.142,27.9999 C113.142,27.9999 99.062,56.1499 87.272,42.4599",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5619,9.4999 C36.1449,9.2039 35.6529,9.0309 35.1419,8.9999 C35.1419,8.9999 31.1419,8.9999 29.1419,13.9999 C27.1419,18.9999 28.1419,56.9999 56.1419,42.9999",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7719,9.4701 C86.1769,9.1911 86.6509,9.0291 87.1419,9.0001 C87.1419,9.0001 91.1419,9.0001 93.1419,14.0001 C95.1419,19.0001 94.1419,57.0001 66.1419,43.0001",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.142,-0.0001 C61.142,-0.0001 42.142,-0.0001 36.142,7.9999 C36.142,7.9999 50.142,44.9999 61.142,44.9999 C72.142,44.9999 86.142,7.9999 86.142,7.9999 C80.142,-0.0001 61.142,-0.0001 61.142,-0.0001 Z",
    id: "Stroke-13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfastNomeal);
export default __webpack_public_path__ + "static/media/breakfast_nomeal.c7d8af346a1d1ca573dba8ed23b98512.svg";
export { ForwardRef as ReactComponent };